export const RECEIVE_SYSTEM_INTERMEDIATE_STATE = 'RECEIVE_SYSTEM_INTERMEDIATE_STATE'
